import React from 'react';
import { ContentfulHeroCta } from '@jbhi-fi/apis/src/contentful/types';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import { CardGridCardProps } from '../../ContentCard/CardGrid/CardGrid';
import { CardTransformer } from './CardTransformer';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { ThemeTransformer } from './ThemeTransformer';
import { ButtonTransformer } from './ButtonTransformer';

export abstract class HeroCtaTransformer {
  static toCardProps = (entry: ContentfulHeroCta): CardGridCardProps => {
    const imageProps = CardTransformer.toCardCoverImageProps(entry);
    const theme = ThemeTransformer.toContentThemeVariables(entry?.fields?.theme);

    return {
      isFixedHeight: true,
      href: CardTransformer.toHref(entry),
      onClick: ButtonTransformer.toClickHandler({
        href: entry?.fields?.url ?? '',
        shouldOpenInNewWindow: entry?.fields?.shouldOpenInNewWindow,
      }),
      cover: imageProps?.src ? (
        <ContentfulImage {...imageProps} />
      ) : entry?.fields?.icon?.fields ? (
        <Icon name={entry?.fields?.icon?.fields?.name} color={theme?.palette?.text} />
      ) : null,
      heading: entry?.fields?.heading,
      content: entry?.fields?.subText,
    };
  };
}
